export default __webpack_public_path__ + "static/media/img-stake-stacking.102a75d1.png";